import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import React from 'react';
import { seededWidth } from '../../seededWidth';
interface RowWithImageProps {
  seed?: number;
}
const RowWithImageSkeleton = t0 => {
  const $ = _c(5);
  const {
    seed: t1
  } = t0;
  const seed = t1 === undefined ? 0 : t1;
  let t2;
  if ($[0] !== seed) {
    t2 = seededWidth(seed, 100);
    $[0] = seed;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const width = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mr-4 h-7 w-7 rounded-full bg-gray-300" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== width) {
    t4 = <div className="flex flex-row items-center" data-sentry-component="RowWithImageSkeleton" data-sentry-source-file="index.tsx">{t3}<div className="h-5 rounded-xs bg-gray-300" style={{
        width
      }} /></div>;
    $[3] = width;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default RowWithImageSkeleton;